<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Student Schedule</h3>
        <br /><br />
        <br /><br />
      </div>
    </div>

    <CCard
      style="top: 0px; right: 0px; bottom: 0px; left: 0px"
      class="custom-default-page h-100 full-height"
    >
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <CCard style="width: 100%; height: 100%" class="p-3 mt-5">
                  <h5 class="ml-3 mb-3">Add New Schedule for Student</h5>
                  <CCol sm="12">
                    <CRow>
                      <CCol class="justify-content-center" sm="12" lg="12">
                        <div>
                          <CCol sm="12" lg="12">
                            <CRow>
                              <CCol sm="4" lg="4"> <label>Group</label></CCol>
                              <CCol sm="8" lg="8">
                                <input
                                  @click="OpenOneToOne"
                                  type="radio"
                                  v-model="group"
                                  value="OneToOne"
                                  required
                                />
                                One To One
                                <input
                                  @click="OpenGroupOfTwo"
                                  type="radio"
                                  class="text-dark ml-4"
                                  v-model="group"
                                  value="GroupOfTwo"
                                  required
                                />
                                Group Of Two
                              </CCol>

                              <CCol v-if="OneToOneForm == true"  sm="12" lg="12">
                                <CRow>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Student</label></CCol
                              >
                              <CCol sm="8" lg="8">
                                <v-select
                                  ref="select"
                                  v-model="SelectedStudent"
                                  :options="students"
                                  label="Name"
                                  placeholder="--Please Select Student Name--"
                                  required
                                >
                                  <span
                                    slot="no-options"
                                    @click="$refs.select.open = false"
                                  >
                                    Please Register Student
                                  </span></v-select
                                >
                              </CCol>
                                </CRow>
                              </CCol>
                              <CCol v-if="GroupOfTwoForm == true" sm="12" lg="12">
                                <CRow>
                                   <CCol sm="4" lg="4" class="mt-3">
                                <label>Student 1</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <v-select
                                  ref="select"
                                  v-model="SelectedStudent"
                                  :options="students"
                                  label="Name"
                                  placeholder="--Please Select Student Name--"
                                  required
                                >
                                  <span
                                    slot="no-options"
                                    @click="$refs.select.open = false"
                                  >
                                    Please Register Student
                                  </span></v-select
                                >
                              </CCol>
                               <CCol sm="4" lg="4" class="mt-3">
                                <label>Student 2</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <v-select
                                  ref="select"
                                  v-model="SelectedStudent2"
                                  :options="students"
                                  label="Name"
                                  placeholder="--Please Select Student Name--"
                                  required
                                >
                                  <span
                                    slot="no-options"
                                    @click="$refs.select.open = false"
                                  >
                                    Please Register Student
                                  </span></v-select
                                >
                              </CCol>
                                </CRow>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Subject</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <v-select
                                  v-model="SelectedSubject"
                                  :options="subjects"
                                  label="SubjectName"
                                  placeholder="--Please Select Subject--"
                                  required
                                ></v-select>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Grade</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <v-select
                                  v-model="SelectedGrade"
                                  :options="grades"
                                  label="GradeName"
                                  placeholder="--Please Select Level--"
                                  required
                                ></v-select>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Language</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <span
                                  v-for="item in languages"
                                  v-bind:key="item.Id"
                                >
                                  <input
                                    type="checkbox"
                                    v-model="item.isAccepted"
                                    class="mr-2 ml-2"
                                  /><span class="text-dark">
                                    {{ item.Name }}
                                  </span>
                                </span>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Session</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <span
                                  v-for="item in sessions"
                                  v-bind:key="item.Id"
                                  style="font-size: 15px"
                                >
                                  <input
                                    type="checkbox"
                                    v-model="item.isAccepted"
                                    class="mr-2 ml-2"
                                  /><span class="text-dark">
                                    {{ item.Name }}
                                  </span>
                                </span>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Time</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <span
                                  v-for="item in times"
                                  v-bind:key="item.Id"
                                  style="font-size: 15px"
                                >
                                  <input
                                    type="checkbox"
                                    v-model="item.isAccepted"
                                    class="mr-2 ml-2"
                                  /><span class="text-dark">
                                    {{ item.Name }}
                                  </span>
                                </span>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Class Duration</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <span v-for="item in dur" v-bind:key="item.Id">
                                  <input
                                    name="item.Id"
                                    type="radio"
                                    value="item.Id"
                                    v-model="durationID"
                                    @change="durationID = item.Id"
                                    class="mr-2 ml-2"
                                  /><span class="text-dark">
                                    {{ item.Name }}
                                  </span>
                                </span>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Teacher</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <v-select
                                  v-model="SelectedTeacher"
                                  :options="list"
                                  label="Name"
                                  placeholder="--Please Select Teacher--"
                                  required
                                ></v-select>
                              </CCol>

                              <CCol sm="4" lg="4" class="mt-3">
                                <label>Start Time</label></CCol
                              >
                              <CCol sm="8" lg="8" class="mt-3">
                                <CInput
                                  type="datetime-local"
                                  v-model="StartTime"
                                />
                              </CCol>
                            </CRow>
                          </CCol>
                        </div>
                      </CCol>
                      <br />

                      <CCol class="justify-content-center mt-4" sm="12" lg="12">
                        <CButton
                        v-if="OneToOneForm == true" 
                          style="background: #1565d8"
                          block
                          color="primary"
                          @click="DirectOneToOne"
                          >Save</CButton
                        >

                          <CButton
                        v-if="GroupOfTwoForm == true" 
                          style="background: #1565d8"
                          block
                          color="primary"
                          @click="DirectGroupOfTwo"
                          >Save</CButton
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CCard>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

    <CModal title="Success" size="sm" color="success" :show.sync="successModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <CCol sm="12">
        <label class="text-center m-0"
          >You have successfully save student schedule.</label
        >
      </CCol>
    </CModal>

    <CModal title="Error" size="sm" color="danger" :show.sync="errorModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconerror.png" />
        </div>
      </CCol>

      <h3 class="text-center">ERROR !</h3>
      <CCol sm="12">
        <label class="text-center m-0">Data Already Exist</label>
      </CCol>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
Vue.use(VuejsDialog);
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      confirm: [],
      dur: [],
      students: [],
      languages: [],
      sessions: [],
      times: [],
      subjects: [],
      list: [],
      grades: [],
      acc: {},
      successModal: false,
      declineModal: false,
      Busy: false,
      status: false,
      SelectedSubject: "",
      SelectedTeacher: "",
      SelectedGrade: "",
      SelectedStudent: "",
        SelectedStudent2: "",
      errorModal: false,

      group: "",
      durationID: "",
      StartTime: "",
      OneToOneForm: true,
      GroupOfTwoForm: false,
    };
  },
  async mounted() {
    await this.GetListOfTeacher();
    await this.GetListOfSubject();
    await this.GetGrade();
    await this.GetListChild();
    this.GetLanguages();
    this.GetSession();
    this.GetTimes();
    this.GetDurations();
  },
  methods: {
    OpenOneToOne()
    {
      this.OneToOneForm = true;
       this.GroupOfTwoForm = false;
    },
    OpenGroupOfTwo()
    {
      this.GroupOfTwoForm = true;
       this.OneToOneForm = false;

    },
    async GetLanguages() {
      return this.$API
        .get(this.$Languages)
        .then(
          function (response) {
            this.languages = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetSession() {
      return this.$API
        .get(this.$Sessions)
        .then(
          function (response) {
            this.sessions = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetTimes() {
      return this.$API
        .get(this.$Times)
        .then(
          function (response) {
            this.times = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    async GetDurations() {
      return this.$API
        .get(this.$Durations)
        .then(
          function (response) {
            this.dur = response.data;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
  
    async GetListChild() {
      console.log("masuk");
      this.$API
        .get(this.$AllStudentName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    async GetListOfTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ListTeacher, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.list = response.data;
            this.FilterList = this.list;
            this.getPic(this.FilterList.PicturePath);
          }
        });
    },
    async GetListOfSubject() {
      this.$API
        .get(this.$ListSubject, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$ListGrade, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },

    DirectOneToOne() {
        
      const formData = new FormData();

      formData.append("IsGroup", false);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorOneToOne, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.successModal = true;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    DirectGroupOfTwo()
    {    
      const formData = new FormData();

      formData.append("IsGroup", true);
      formData.append("StudentId", this.SelectedStudent.Id);
      formData.append("studentId2", this.SelectedStudent2.Id);
      formData.append("TeachingSubjectId", this.SelectedSubject.Id);
      formData.append("TeachingGradeId", this.SelectedGrade.Id);
      formData.append("DurationId", this.durationID);
      formData.append("StartTime", this.StartTime);
      formData.append("DataMessage", this.SelectedSubject.SubjectName);
      formData.append("teacherId", this.SelectedTeacher.TeacherId);

      var combinedLanguage = [];
      for (let i in this.languages) {
        let item = this.languages[i];
        combinedLanguage.push({
          LanguageId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let languageData = JSON.stringify(combinedLanguage);
      formData.append("Language", languageData);

      var combinedSession = [];
      for (let i in this.sessions) {
        let item = this.sessions[i];
        combinedSession.push({
          SessionId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let sessionData = JSON.stringify(combinedSession);
      formData.append("Session", sessionData);

      var combinedTime = [];
      for (let i in this.times) {
        let item = this.times[i];
        combinedTime.push({
          TimeId: item.Id,
          IsAccept: item.isAccepted === undefined ? false : item.isAccepted,
        });
      }

      let timeData = JSON.stringify(combinedTime);
      formData.append("Time", timeData);

      return this.$API
        .post(this.$InsertDirectFindTutorGrouping, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (
            response.status == 200 &&
            response.data != null &&
            response.data > 0
          ) {
            this.successModal = true;
          } else {
            this.errorModal = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });

    }
  },
};
</script>
